import { render, staticRenderFns } from "./GrabFood.vue?vue&type=template&id=1b8231e0"
import script from "./GrabFood.vue?vue&type=script&lang=js"
export * from "./GrabFood.vue?vue&type=script&lang=js"
import style0 from "./GrabFood.vue?vue&type=style&index=0&id=1b8231e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports